import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { FC } from 'react';
import { IMenu } from './../../model/IMenu';


export const CustomMenu: FC<{menu:IMenu}> = (props) => {

    const _menuFilter =  props.menu.items.filter(menu => !menu.excludeMenu)

    return (
        <>
            <Menu
                overflowedIndicator={<span className='span-menu-title'>Mas <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.91745 8.9976C7.76526 8.99915 7.61836 8.94182 7.50745 8.8376L0.177444 2.0276C0.121508 1.97186 0.0771277 1.90562 0.0468445 1.83269C0.0165613 1.75976 0.000976562 1.68157 0.000976562 1.6026C0.000976562 1.52363 0.0165613 1.44544 0.0468445 1.37251C0.0771277 1.29958 0.121508 1.23334 0.177444 1.1776C0.233187 1.12166 0.299422 1.07728 0.372353 1.047C0.445284 1.01671 0.523479 1.00113 0.602448 1.00113C0.681416 1.00113 0.759611 1.01671 0.832542 1.047C0.905473 1.07728 0.971708 1.12166 1.02745 1.1776L7.94745 7.6076L15.0174 1.1676C15.1296 1.05767 15.2804 0.996094 15.4374 0.996094C15.5945 0.996094 15.7453 1.05767 15.8574 1.1676C15.9146 1.22265 15.9601 1.28865 15.9911 1.36168C16.0222 1.4347 16.0382 1.51325 16.0382 1.59261C16.0382 1.67196 16.0222 1.75049 15.9911 1.82352C15.9601 1.89654 15.9146 1.96257 15.8574 2.01761L8.38745 8.82761C8.32717 8.88978 8.25351 8.9374 8.17207 8.96686C8.09064 8.99631 8.00356 9.00683 7.91745 8.9976Z" fill="#002570"/>
                     </svg>
                 </span>}
                    theme="light"
                    mode="horizontal"
                    items={_menuFilter.map((_, index) => ({
                        key: String(index + 1),
                        label:
                        <>
                            <span className='span-menu-title'>{_.nombre}</span>
                            <Link to={_.url} ></Link>
                        </>,
                }))
                }
            />


        </>
    )
}

